import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Typography } from "@material-ui/core";
import { Email, Phone, Person, LocationOn } from "@material-ui/icons";
import { Trans } from "@lingui/macro";
import theme from "../../../theme-admin";

const useStyles = makeStyles((th) => ({
  contactBox: {
    display: "flex",
    flexDirection: "row",
    gap: th.spacing(2),
    color: th.palette.white,
    [th.breakpoints.down("xs")]: {
      flexDirection: "column",
      alignItems: "center",
      gap: th.spacing(1),
      padding: th.spacing(2),
    },
  },
  iconContainer: { display: "flex", alignItems: "center", gap: th.spacing(1) },
  icon: { width: 32, height: 32 },
  boldText: { fontWeight: "bold" },
  socialLink: { color: th.palette.white, textDecoration: "none" },
}));

export const ContactPointRow = ({ contact }) => {
  const classes = useStyles(theme);

  return (
    <Box className={classes.contactBox}>
      {contact.state && (
        <Box className={classes.iconContainer}>
          <LocationOn className={classes.icon} />
          <Typography>{contact.state}</Typography>
        </Box>
      )}

      {contact.person && (
        <Box className={classes.iconContainer}>
          <Person className={classes.icon} />
          <Typography>{contact.person}</Typography>
        </Box>
      )}

      {contact.phone && (
        <Box className={classes.iconContainer}>
          <Phone className={classes.icon} />
          <Typography className={classes.boldText}>
            <Trans>Phone</Trans>:
          </Typography>
          <a href={`tel:${contact.phone}`} className={classes.socialLink}>
            <Typography>{contact.phone}</Typography>
          </a>
        </Box>
      )}
      {contact.email && (
        <Box className={classes.iconContainer}>
          <Email className={classes.icon} />
          <Typography className={classes.boldText}>
            <Trans>Email</Trans>:
          </Typography>
          <a href={`mailto:${contact.email}`} className={classes.socialLink}>
            <Typography>{contact.email}</Typography>
          </a>
        </Box>
      )}
    </Box>
  );
};
